import MapSavePOI from './MapSavePOI'
export default MapSavePOI;


// WEBPACK FOOTER //
// ./src/common/components/MapMenu/MapSavePOI/index.js